import styled, { css } from 'styled-components';
import Padding from './padding';

// translateY(-16.66666666%); fully assumes 3 equal height blocks. Built for ligier.
const ZeroHeight = styled.div`
  ${Padding} {
    transform: translateY(-16.66666666%);
    margin-bottom: -16.66666666%;
  }

  @media all and (min-width: ${(props) => props.theme.breakingpoints.md}) {
    ${({ $padding }) => ['zeroheight'].includes($padding) && css`
      height: 0rem;
    `}
    ${({ $padding }) => ['pullover'].includes($padding) && css`
      height: 5rem;
    `}
    ${({ $padding }) => ['zeroheight', 'pullover'].includes($padding) && css`
      ${Padding} {
        margin-bottom: unset;
        transform: translateY(-50%);
      }
    `}
  }
`;

export default ZeroHeight;
